/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Badge } from '../models/Badge';
import type { HistoryEntry } from '../models/HistoryEntry';
import type { LevelAndRankConfig } from '../models/LevelAndRankConfig';
import type { UserStats } from '../models/UserStats';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommunityGamificationService {
    /**
     * Get the user's level stats
     * @param communityName
     * @returns UserStats OK
     * @throws ApiError
     */
    public static getUserLevelStats(
        communityName: string,
    ): CancelablePromise<UserStats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/{communityName}/stats',
            path: {
                'communityName': communityName,
            },
        });
    }
    /**
     * Gets a user's list of badges
     * @param communityName
     * @returns Badge OK
     * @throws ApiError
     */
    public static getBadges(
        communityName: string,
    ): CancelablePromise<Array<Badge>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/{communityName}/badges',
            path: {
                'communityName': communityName,
            },
        });
    }
    /**
     * Get the kudos messages of all rewards of own user since a given date
     * @param checkKudosSinceDate The datetime is in UTC as milliseconds at midnight (example: 02.06.2023 -> 1685664000000), to create a timestamp in this format use https://www.timestamp-converter.com
     * @returns string OK
     * @throws ApiError
     */
    public static getKudos(
        checkKudosSinceDate: number,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/gamification/kudos/{checkKudosSinceDate}',
            path: {
                'checkKudosSinceDate': checkKudosSinceDate,
            },
        });
    }
    /**
     * Get the history of all rewards of own user
     * @returns HistoryEntry OK
     * @throws ApiError
     */
    public static getHistory(): CancelablePromise<Array<HistoryEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/gamification/history',
        });
    }
    /**
     * Get the level and rank configuration of own user
     * @returns LevelAndRankConfig OK
     * @throws ApiError
     */
    public static getLevelAndRankConfig(): CancelablePromise<LevelAndRankConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/gamification/config',
        });
    }
}
